<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-container fluid grid-list-md>
        <p v-if="!hasDocuments">Нет документов для отображения</p>
        <v-data-table
          v-if="hasDocuments"
          :items="documents"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr>
              <th>Документ</th>
              <th>Описание</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td><a :href="props.item.file" target="_blank">{{ props.item.name }}</a></td>
              <td>{{ props.item.description }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import Documents from '@/orm/models/Documents';

export default {
  name: 'DocumentsIndex',
  data() {
    return {
      rowsPerPageItems: [
        10,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  async asyncData({ route }) {
    await Documents.deleteAll();
    await Documents.$fetch();
  },
  computed: {
    hasDocuments() {
      return this.documents.length > 0;
    },
    documents() {
      return Documents.query().orderBy('order').get();
    },
  },
  methods: {
    getFullUrl(item) {
      if (item.external_link) {
        return item.external_link;
      } else if (item.local_file) {
        return item.local_file
      }

      return '';
    }
  }
};
</script>
